import { useSearchParams } from 'react-router-dom'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'

import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import { SelectedProductsSlice } from 'featureSliced/shared/store/reducers/SelectedProductsReducer'

import { useTranslations } from './useTranslations'
import { NoReceiptModal } from 'components/ReceiptModal/NoReceiptModal'
import { clickCollectPOST } from '../api/clickCollect/POST'
import { Card } from 'featureSliced/features/Profile/Card'
import { qrMenuPOST } from '../api/qrMenu/POST'
import { Payment } from 'featureSliced/features/Profile/Payment'
import { delay } from '../utils/delay'

export type useCompleteDataTransType = () => void

export const useCompleteDataTransCC = (): useCompleteDataTransType => {
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const [searchParams, setSearchParams] = useSearchParams()

  // Store
  const isAppInit = useMySelector((state) => state.app.isAppInit)
  const clearBucket = QRMBucketSlice.actions.clearBucket
  const discardSelectedProducts =
    SelectedProductsSlice.actions.discardSelectedProducts

  // Variables
  const show_card = searchParams.get('show_card')
  const order_guid = searchParams.get('orderGuid')
  const datatransTrxId = searchParams.get('datatransTrxId')
  const payment_success_nr = searchParams.get('payment_success_nr')
  const show_payment_variant = searchParams.get('show_payment_variant')

  // Functions
  const completeDataTransCC = async () => {
    console.log(234)
    try {
      if (
        isAppInit &&
        datatransTrxId &&
        (order_guid || show_card || show_payment_variant)
      ) {
        const isDefaultPayment = !show_card && !show_payment_variant
        const isCCUpdate = !show_card && show_payment_variant
        const isLoyaltyRefill = show_card && !show_payment_variant

        if (isDefaultPayment) {
          openNoReceiptModal(payment_success_nr || undefined)
        }
        if (isCCUpdate) {
          completeCreditCardUpdate()
        }
        if (isLoyaltyRefill) {
          completeCardRefill() // REENABLE
        }
      }
    } catch (e) {
      searchParams.delete('show_card')
      searchParams.delete('datatransTrxId')
      searchParams.delete('show_payment_variant')
      setSearchParams(searchParams)
    }
  }

  const completeCreditCardUpdate = async () => {
    const success = await qrMenuPOST.completeNewPaymentVariant(
      datatransTrxId as string
    )
    if (success) {
      openModal({
        id: 'USER_CREDIT_CARD',
        title: '',
        components: [() => <Payment />],
      })
    }
    searchParams.delete('show_payment_variant')
    searchParams.delete('datatransTrxId')
    setSearchParams(searchParams)
  }

  const completeCardRefill = async () => {
    const success = await clickCollectPOST.refillCardComplete(datatransTrxId)
    if (success) {
      await delay(300)
      openModal({
        id: 'USER_CARD',
        title: '',
        components: [() => <Card />],
      })
    }
    searchParams.delete('show_card')
    searchParams.delete('datatransTrxId')
    setSearchParams(searchParams)
  }

  const openNoReceiptModal = (numberToDisplay?: string) => {
    openModal({
      id: 'NO_RECEIPT_MODAL',
      // title: t('order.toMenu'),
      components: [
        ({ closeThisModal }) => (
          <NoReceiptModal
            paymentNumberProps={numberToDisplay}
            onCloseModal={async () => {
              closeThisModal()
              handleReceiptModalClose()
            }}
          />
        ),
      ],
      onClose: handleReceiptModalClose,
    })
  }

  const handleReceiptModalClose = () => {
    searchParams.delete('payment_success_nr')
    searchParams.delete('datatransTrxId')
    searchParams.delete('order_guid')
    searchParams.delete('orderGuid')
    setSearchParams(searchParams)
    clearLocalStorage()
    dispatch(discardSelectedProducts())
    dispatch(clearBucket())
  }

  const clearLocalStorage = () => {
    window.localStorage.removeItem('products_notes')
  }

  return completeDataTransCC
}
